<template>
  <div class="view">

	<box label="Tema editor">

    <div class="cols cols-3">
      <template v-for="(v,k,i) in edited_theme">
        <div class="inputfield">
          <label>{{k}}</label>
          <input type="text" :value="v" @change="updateTheme(k,$event)">
        </div>
      </template>
    </div>

	</box>

  <div class="filterbtns">
    <filterbtn :active="true">UI example 1</filterbtn>
    <filterbtn :active="false">UI example 2</filterbtn>
    <filterbtn :active="false">UI example 3</filterbtn>
  </div>
  
  <box label="UI examples">    
    
    <btn>Btn color1</btn>
    <btn color="2">Btn color2</btn>
    <btn color="3">Btn color3</btn>
    <btn color="4">Btn color4</btn>
    <btn color="4" disabled>Btn disabled</btn>

    <inputfield label="hay" icon="linearicons/arrow-left">
      <input type="text" v-model="var1">
    </inputfield>
    
  </box> 

  </div>
</template>

<script>
import themes from '../themes.js'
import mixins from '../mixins.js';
import helpers from '../helpers.js';
import Box from '.././components/Box'
import Btn from '.././components/Btn'
import Avatar from '.././components/Avatar'
import Filterbtn from '.././components/Filterbtn'
export default {
  data: function () {
    return {
      globals: this.$parent.globals,
      themes,

      edited_theme: {},

    }
  },
  mixins: [ mixins.db, mixins.generic ],
  components: { Box, Btn, Avatar, Filterbtn },
  computed:{

    active_theme_key(){
      return localStorage.getItem('user_theme_key')
    },

    active_theme(){
      if( !this.active_theme_key ) return
      if( !this.themes ) return
      if( this.active_theme_key == 'custom' ) {
        return JSON.parse(localStorage.getItem('user_theme_custom'))
      }
      return this.themes[ this.active_theme_key ]
    },

  },//computed
  methods: {

    updateTheme(key,e){

      var val = e.target.value
      this.edited_theme[key] = val
      
      eventBus.$emit('apply_ui_theme', { theme_key: 'custom', theme: this.edited_theme })
      
    },

  },//methods

  mounted(){

    this.edited_theme = JSON.parse(JSON.stringify(this.active_theme))

  },
}
</script>



// WEBPACK FOOTER //
// ThemeMachine.vue?2f5c6cb0